import { findTipospublicacao } from '@/services/tipospublicacao';
import { findSegmentos } from '@/services/segmentos';
import { keyWords } from '@/services/relatorio';
import notifyError from '@/lib/notify-error';

const Getters = {
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  query(st, gt, rSt) {
    const query = [];
    if (rSt.route.query) {
      if (rSt.route.query.idTipopublicacao) {
        const data = st.tipoPublicacoes.find(seg => Number(seg.idTipopublicacao)
            === Number(rSt.route.query.idTipopublicacao));
        if (data) {
          query.push({
            title: 'Tipo de acervo',
            data: data.tipoPublicacao,
          });
        }
      } else {
        query.push({
          title: 'Tipo de acervo',
          data: 'Todos',
        });
      }
      if (rSt.route.query.idSegmento) {
        const data = st.segmentos.find(seg => Number(seg.id)
        === Number(rSt.route.query.idSegmento));
        if (data) {
          query.push({
            title: 'Área',
            data: data.segmento,
          });
        }
      } else {
        query.push({
          title: 'Área',
          data: 'Todas',
        });
      }
      if (rSt.route.query.palavrachave) {
        query.push({
          title: 'Palavra-chave',
          data: rSt.route.query.palavrachave,
        });
      } else {
        query.push({
          title: 'Palavra-chave',
          data: 'Todas',
        });
      }
      return query;
    }
    return [];
  },
  result(st) {
    return st.result;
  },
  loading(st) {
    return st.loading;
  },
  csvData(st) {
    if (st.result && st.result.publicacoes) {
      return st.result.publicacoes.map(res => ({
        registro: res.registro.trim(),
        titulo: res.titulo,
        localizacao: res.localizacao,
        palavrasChave: res.palavrasChave,
      }));
    }
    return [];
  },
  palavrasChaveQtd(st, gt) {
    if (gt.palavrasChaveFull) {
      return Object.keys(gt.palavrasChaveFull).length;
    }
    return 0;
  },
  palavrasChaveFull(st, gt, rSt) {
    const groupBy = (xs, key) => xs.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
    if (st.result && st.result.publicacoes) {
      // cria o array de palavras-chave e filtra caso o usuário tenha selecionado
      // uma na query
      const palavrasChave = st.result.publicacoes.reduce((acc, pub) => {
        pub.palavrasChaveFull.forEach((pc) => {
          pc.palavrachave = pc.palavrachave.toLowerCase();
          if (rSt.route.query.palavrachave) {
            if (rSt.route.query.palavrachave.toLowerCase() === pc.palavrachave) {
              acc.push(pc);
            }
          } else {
            acc.push(pc);
          }
        });
        return acc;
      }, []);
      // agrupa pela palavra-chave
      const result = groupBy(palavrasChave, 'palavrachave');
      // ordena as chaves da maior para a menor
      const sortKeys = Object.keys(result).sort();
      // reconstrói o objeto ordenado
      const obj = {};
      sortKeys.forEach((key) => {
        obj[key] = result[key];
      });
      return obj;
    }
    return [];
  },
};
const mutations = {
  setTipoPublicacoes(state, tipoPublicacoes) {
    state.tipoPublicacoes = tipoPublicacoes;
  },
  setSegmentos(state, segmentos) {
    state.segmentos = segmentos;
  },
  setResult(state, result) {
    state.result = result;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};
const actions = {
  afterRouteUpdate({ dispatch }) {
    dispatch('findTipospublicacao');
    dispatch('findSegmentos');
    dispatch('getResult');
  },
  findTipospublicacao({ commit }) {
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setTipoPublicacoes', items));
  },
  findSegmentos({ commit }) {
    findSegmentos({ where: { idCanalPadrao: 273 } })
      .then(items => commit('setSegmentos', items));
  },
  getResult({ rootState, commit }) {
    commit('setLoading', true);
    keyWords(rootState.route.query)
      .then(result => commit('setResult', result))
      .catch(err => notifyError(err))
      .finally(() => {
        commit('setLoading', false);
      });
  },
};


export default {
  namespaced: true,
  state: {
    segmentos: [],
    tipoPublicacoes: [],
    result: {},
    loading: false,
  },
  mutations,
  getters: Getters,
  actions,
};
